import Image from 'next/image'

import { CrossSell } from '~/generated/graphql'

import { Description, ImageWrapper, TextWrapper, Title, Wrapper } from './ReservableCrossSellItemShards'

export type ReservableCrossSell = Pick<CrossSell, 'name' | 'description' | 'id' | 'festivalDrink'> & {
  image?: Pick<NonNullable<CrossSell['image']>, 'preview'> | null
}

interface Props {
  crossSell: ReservableCrossSell
}

const ReservableCrossSellItem = ({ crossSell }: Props) => {
  const { name, description, image } = crossSell

  return (
    <Wrapper>
      <ImageWrapper>{image?.preview && <Image width={80} src={image?.preview} layout='fill' objectFit='contain' />}</ImageWrapper>
      <TextWrapper>
        <Title>{name}</Title>
        <Description title={description}>{description ?? ''}</Description>
      </TextWrapper>
    </Wrapper>
  )
}

export default ReservableCrossSellItem
